import { render } from "./InterestsArea.vue?vue&type=template&id=1e046bbf&scoped=true"
import script from "./InterestsArea.vue?vue&type=script&lang=js"
export * from "./InterestsArea.vue?vue&type=script&lang=js"

import "./InterestsArea.vue?vue&type=style&index=0&id=1e046bbf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e046bbf"]])

export default __exports__